export default __webpack_public_path__ + "static/media/icon-3pts-blanc.0dfca86f.svg";